/**
 * Theme constants for the application
 * This centralizes styling values to avoid hardcoding throughout the codebase
 */

export const colors = {
  primary: {
    main: '#28724f',
    dark: '#143927',
    light: '#4a9e77',
  },
  secondary: {
    main: '#012b3b',
    dark: '#001a24',
    light: '#0a4d6a',
  },
  text: {
    primary: '#0F0F0F',
    secondary: '#545454',
    light: '#767676',
  },
  background: {
    main: '#ffffff',
    light: '#F9F9F6',
    offWhite: '#F5F5F5',
    border: '#F2F2ED',
  },
  status: {
    error: '#E53E3E',
    success: '#38A169',
    warning: '#DD6B20',
    info: '#3182CE',
  },
};

export const spacing = {
  xs: '0.5rem',
  sm: '1rem',
  md: '1.5rem',
  lg: '2rem',
  xl: '3rem',
  xxl: '5rem',
};

export const breakpoints = {
  sm: '30em', // 480px
  md: '48em', // 768px
  lg: '62em', // 992px
  xl: '80em', // 1280px
  xxl: '90em', // 1440px
};

export const fontSizes = {
  xs: '12px',
  sm: '14px',
  md: '16px',
  lg: '18px',
  xl: '20px',
  '2xl': '24px',
  '3xl': '30px',
  '4xl': '36px',
  '5xl': '48px',
};

export const borderRadius = {
  sm: '0.25rem',
  md: '0.5rem',
  lg: '0.75rem',
  xl: '1rem',
  full: '9999px',
};

const theme = {
  colors,
  spacing,
  breakpoints,
  fontSizes,
  borderRadius,
};

export default theme;
